import API, { APIv2 } from "./API"

// VERSION 1
//----------------------------------------------

const fetchJohnDeereUrls = (org_id) => {
  if(org_id !== undefined) {
    return API.get(`jdurl/?orgid=${org_id}`)
  }
  return API.get("jdurl")
}

const fetchJohnDeereConnectionErrors = () => API.get("/jdauth/unread_errors/")

const fetchJohnDeereStage = () => API.get("jd-stage")

const fetchJohnDeereOrgs = () => API.get("/jd-org")

const refreshJohnDeereOrgs = () => API.get("/jd-org/refresh/")

const fetchJohnDeereSynclog = (synclog_id) => API.get(`/jd-org-synclogs/${synclog_id}/`)

const importJohnDeereData = (data_type, payload) =>
  API.post(`/jd-org/import_data/?data_type=${data_type}`, payload)

const configureJohnDeereOrg = payload => API.post(`/jd-org/set_org/`, payload)

const updateJohnDeereClients = (pk, payload) => API.post(`/jd-org/${pk}/set_clients/`, payload)

// VERSION 2
//----------------------------------------------

const fetchJohnDeereVersion = () => APIv2.get("jdversion")

const fetchJohnDeereUrlsV2 = () => APIv2.get("jdurl")

const fetchJohnDeereConnectionErrorsV2 = () => APIv2.get("/jdauth/unread_errors/")

const fetchJohnDeereOrgsV2 = () => APIv2.get("/jd-org")

const refreshJohnDeereOrgsV2 = () => APIv2.get("/jd-org/refresh/")

const updateJohnDeereOrgMappingsV2 = (pk, payload) => APIv2.post(`/jd-org/${pk}/set_org_mappings/`, payload)

const fetchJohnDeereSynclogV2 = (synclog_id) => APIv2.get(`/jd-org-synclogs/${synclog_id}/`)

const importJohnDeereDataV2 = (payload) => APIv2.post("/jd-org/import_data/", payload)

const configureJohnDeereOrgV2 = payload => APIv2.post(`/jd-org/set_org/`, payload)

const updateJohnDeereClientsV2 = (pk, payload) => APIv2.post(`/jd-org/${pk}/set_clients/`, payload)

export default {
  // Version 1
  fetchJohnDeereUrls,
  fetchJohnDeereStage,
  fetchJohnDeereOrgs,
  refreshJohnDeereOrgs,
  fetchJohnDeereSynclog,
  importJohnDeereData,
  configureJohnDeereOrg,
  updateJohnDeereClients,
  fetchJohnDeereConnectionErrors,
  // Version 2
  fetchJohnDeereVersion,
  fetchJohnDeereUrlsV2,
  fetchJohnDeereOrgsV2,
  refreshJohnDeereOrgsV2,
  updateJohnDeereOrgMappingsV2,
  fetchJohnDeereSynclogV2,
  importJohnDeereDataV2,
  configureJohnDeereOrgV2,
  updateJohnDeereClientsV2,
  fetchJohnDeereConnectionErrorsV2,
}
